import { call, put, takeLatest } from 'redux-saga/effects';

import i18n from 'i18n';

import {
  CHANGE_LANGUAGE_REQUEST,
  changeLanguageSuccess,
  changeLanguageFailure
} from 'store/language';

function* changeLanguage(action) {
  try {
    yield call(
      () =>
        new Promise((resolve, reject) => {
          i18n.changeLanguage(action.payload.language, error => {
            error ? reject(error) : resolve();
          });
        })
    );

    yield put(changeLanguageSuccess(action.payload.language));
  } catch (err) {
    yield put(changeLanguageFailure(err));
  }
}

export default function* languageSaga() {
  yield takeLatest(CHANGE_LANGUAGE_REQUEST, changeLanguage);
}



// WEBPACK FOOTER //
// ./src/store/language/sagas.js